import React, { useContext, useState } from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { IconLayoutGrid, IconArrowNarrowLeft, IconHome } from '@tabler/icons-react';
import { GlobalContext } from '../contexts/GlobalContext'
import { useNavigate } from "react-router-dom";

function Layout(props) {
    const { portal } = useContext(GlobalContext);
    const navigate = useNavigate();

    // const goBack = (event) => {
    //     if(Object.hasOwn(props, 'backToHome')) {
    //         if(portal == "supplier") {
    //             return navigate("/supplier/")
    //         } else {
    //             return navigate("/buyer/")
    //         }
    //     } else {
    //         return navigate(-1)
    //     }
    // }

    const goBack = () => {

      if (props.backToHome) {
        if (portal === "supplier") {
          navigate("/supplier/");
        } else {
          navigate("/buyer/");
        }
      } else if (props?.backToTab) {
        if (portal === "supplier") {
          navigate(props?.link);
        } else {
          navigate(props?.link);
        }
      } else {
        navigate(-1, {
          onSuccess: () => {
            if(props?.backToTop){
              window.scrollTo({
                top: 0,
                behavior: "auto",
              })
            }
          },
        });
      }

      if(props?.backToTop) {        
          window.scrollTo({
            top: 0,
            behavior: "auto",
          })
      }
        
      };

    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            minHeight: '100vh',
            pb: 'calc(1.25rem + env(safe-area-inset-bottom))' 
        }}>
            <AppBar 
                position="sticky" 
                color="secondary" 
                elevation={0} // Often helps with "jumpy" shadows on iOS
                sx={{ 
                    backgroundImage: "none", 
                    paddingTop: 'calc(1rem + env(safe-area-inset-top))',
                    px: '16px', // Shorthand for left/right padding
                    pb: '8px' 
                }}
            >
                <Toolbar disableGutters sx={{ minHeight: '64px' }}>
                    {!props.hasOwnProperty('hideNavigation') && (
                        <IconButton size="large" edge="start" color="inherit" onClick={() => goBack()}>
                            <IconArrowNarrowLeft />
                        </IconButton>
                    )}
                    <Typography component="p" sx={{ flexGrow: 1, textAlign: 'center', fontSize: "1.1em" }}>
                        {props.title}
                    </Typography>
                    {!props.hasOwnProperty('hideNavigation') && (
                        <IconButton size="large" edge="end" color="inherit" onClick={() => navigate(portal === "supplier" ? "/supplier/" : "/buyer/")}>
                            <IconHome />
                        </IconButton>
                    )}
                </Toolbar>
            </AppBar>

            {props.hasOwnProperty('nopadding') ? (
                props.children
            ) : (
                <Box sx={{ p: 2 }}>{props.children}</Box>
            )}
        </Box>
    );
}
export default Layout;
